import "./BodhiInput.css";

/**
 * BodhiInput — branded single-line text input. Pure CSS, no antd.
 *
 * Props:
 *   value / onChange   controlled value + native change handler (e.target.value)
 *   placeholder
 *   type               native input type (default "text")
 *   size               "sm" | "md" | "lg" (default "md")
 *   prefix / suffix    inline nodes rendered inside the field
 *   disabled
 *   className / style   extra class / inline style on the wrapper
 *   …rest              forwarded to the native <input>
 */
const BodhiInput = ({
	value,
	onChange,
	placeholder,
	type = "text",
	size = "md",
	prefix,
	suffix,
	disabled = false,
	className = "",
	style,
	...rest
}) => {
	const cls = [
		"bodhi-input-wrap",
		`bodhi-input-${size}`,
		disabled && "bodhi-input-disabled",
		className,
	]
		.filter(Boolean)
		.join(" ");

	return (
		<span className={cls} style={style}>
			{prefix && <span className="bodhi-input-prefix">{prefix}</span>}
			<input
				className="bodhi-input"
				type={type}
				value={value}
				onChange={onChange}
				placeholder={placeholder}
				disabled={disabled}
				{...rest}
			/>
			{suffix && <span className="bodhi-input-suffix">{suffix}</span>}
		</span>
	);
};

export default BodhiInput;
